import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import './KebabMenu.css';

const KebabMenu = ({ onEdit, onDelete, onClick }) => {
  const t = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleEdit = (e) => {
    e.stopPropagation();
    setIsOpen(false);
    onEdit();
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    setIsOpen(false);
    onDelete();
  };

  return (
    <div className="kebab-menu-container" ref={menuRef} onClick={onClick}>
      <button
        className="kebab-menu-button"
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        title={t('creditCardsInventory.moreOptions')}
      >
        <span className="kebab-dots">⋮</span>
      </button>
      {isOpen && (
        <div className="kebab-menu-dropdown">
          <button
            className="kebab-menu-item"
            onClick={handleEdit}
          >
            <span className="kebab-icon">✏️</span>
            {t('creditCardsInventory.edit')}
          </button>
          <button
            className="kebab-menu-item kebab-menu-item-danger"
            onClick={handleDelete}
          >
            <span className="kebab-icon">🗑️</span>
            {t('creditCardsInventory.delete')}
          </button>
        </div>
      )}
    </div>
  );
};

export default KebabMenu;

